import { Stack, styled } from "@mui/material";
import { LgTextSemiBold, RFQ, Row, Swiper, ViewAllText } from "Components";
import RFQSkeleton from "Components/skeleton/RFQSkeleton";
import { AUTO_PLAY_ITEM_TIME, HOME_SLIDE_BREAKPOINTS } from "constants/layout";
import { PATHS } from "constants/routes";
import useGetData from "hooks/useGetData";
import useSlideHeight from "hooks/useSlideHeight";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { apiFeaturedRFQs } from "services/api/rfq";
import { SwiperSlide } from "swiper/react";
import { RFQType } from "types/rfq";
import SwiperCore, { Autoplay } from "swiper";

type Props = {};

SwiperCore.use([Autoplay]);

const FeatureRFQs = (props: Props) => {
  const intl = useIntl();
  const { isLoading, data } = useGetData({
    promise: apiFeaturedRFQs,
  });
  const rfqs = useMemo(() => data?.data || [], [data]);

  const maxHeight = useSlideHeight("featured-swiper", isLoading, [
    rfqs,
    isLoading,
  ]);

  return (
    <StyledFeatureRFQs className="card">
      <Row mb={1} justifyContent="space-between">
        <LgTextSemiBold className="title">
          {intl.formatMessage({ id: "featured_buying_leads" })}
        </LgTextSemiBold>
        <ViewAllText href={PATHS.buyleads} />
      </Row>

      <Swiper
        pagination={undefined}
        breakpoints={HOME_SLIDE_BREAKPOINTS}
        className="featured-swiper"
        autoplay={{
          delay: AUTO_PLAY_ITEM_TIME,
          disableOnInteraction: false,
        }}
      >
        {isLoading &&
          Array.from(new Array(6)).map((_, index) => (
            <SwiperSlide
              key={index}
              style={{ height: maxHeight ? `${maxHeight}px` : "auto" }}
            >
              <RFQSkeleton />
            </SwiperSlide>
          ))}
        {(rfqs || []).map((rfq: RFQType, i: number) => (
          <SwiperSlide
            key={i}
            style={{ height: maxHeight ? `${maxHeight}px` : "auto" }}
          >
            <RFQ {...{ rfq }} />
          </SwiperSlide>
        ))}
      </Swiper>
    </StyledFeatureRFQs>
  );
};

const StyledFeatureRFQs = styled(Stack)(({ theme }) => ({
  ".mySwiper": {
    paddingBottom: 0,
  },
  [theme.breakpoints.down("md")]: {
    padding: 8,
    borderRadius: 0,
    "& .swiper-slide": {},
  },
}));

export default FeatureRFQs;
